module.exports = __webpack_public_path__ + "img/title-bg.c5ef9dbf.png";